import cyrillicToTranslit from 'cyrillic-to-translit-js';
import { diff } from 'deep-object-diff';
import { saveAs } from 'file-saver';

import {
  INFO_STATUS_BAR_TRANSLATE,
  SUPPLY_STATUS_TRANSLATE,
  SELECTION_BY_DATE_TRANSLATE,
} from '../config';

import mockImg from '../assets/images/no-image.png';
import numeral from 'numeral';
import React from 'react';

export const getItemPriceString = (item, variant, currencySymbol) => {
  if (variant) {
    return variant.price ? `${variant.price} ${currencySymbol}` : '';
  }

  if (!item.variants || !item.variants.length) {
    return '';
  }

  if (!item.variants[0].optionsUsed) {
    return item.variants[0].price ? `${item.variants[0].price} ${currencySymbol}` : '';
  }

  let min = 0;

  item.variants.forEach((variant) => {
    if (!min) {
      if (Number(variant.price) !== 0) {
        min = variant.price;
      }
    } else {
      if (variant.price < min && Number(variant.price) !== 0) {
        min = variant.price;
      }
    }
  });

  return min ? `от ${min} ${currencySymbol}` : '';
};

export const getItemVariantsString = (count, t = null) => {
  let resultStr = count + ' ';
  const strLength = String(count).length;
  if ([11, 12, 13, 14].indexOf(Number(count)) !== -1) {
    resultStr += t ? t('вариантов') : 'вариантов';
  } else {
    const symbol = strLength > 1 ? String(count)[strLength - 1] : count;
    switch (Number(symbol)) {
      case 1:
        resultStr += t ? t('вариант') : 'вариант';
        break;
      case 2:
      case 3:
      case 4:
        resultStr += t ? t('варианта') : 'варианта';
        break;
      default:
        resultStr += t ? t('вариантов') : 'вариантов';
    }
  }
  return resultStr;
};

export const getItemMonoboxesString = (count, t = null) => {
  let resultStr = count + ' ';
  const strLength = String(count).length;
  if ([11, 12, 13, 14].indexOf(Number(count)) !== -1) {
    resultStr += t ? t('монокоробов') : 'монокоробов';
  } else {
    const symbol = strLength > 1 ? String(count)[strLength - 1] : count;
    switch (Number(symbol)) {
      case 1:
        resultStr += t ? t('монокороб') : 'монокороб';
        break;
      case 2:
      case 3:
      case 4:
        resultStr += t ? t('монокороба') : 'монокороба';
        break;
      default:
        resultStr += t ? t('монокоробов') : 'монокоробов';
    }
  }
  return resultStr;
};

export const getItemsString = (count) => {
  let resultStr = count + ' ';
  const strLength = String(count).length;
  if ([11, 12, 13, 14].indexOf(Number(count)) !== -1) {
    resultStr += 'товаров';
  } else {
    const symbol = strLength > 1 ? String(count)[strLength - 1] : count;
    switch (Number(symbol)) {
      case 1:
        resultStr += 'товар';
        break;
      case 2:
      case 3:
      case 4:
        resultStr += 'товара';
        break;
      default:
        resultStr += 'товаров';
    }
  }
  return resultStr;
};

export const getDaysString = (count) => {
  function declension(number, words) {
    var cases = [2, 0, 1, 1, 1, 2];
    return words[
      number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]
    ];
  }

  return declension(count, ['день', 'дня', 'дней']);
};

export const preventSubmittingByEnter = (keyEvent) => {
  //В textarea не нужно блокировать enter. В этом элементе он не вызывает submit формы. Но при этом он там нужен для перевода строк.
  if ((keyEvent.charCode || keyEvent.keyCode) === 13 && keyEvent.target.tagName !== 'TEXTAREA') {
    keyEvent.preventDefault();
  }
};

export const createTranslitId = (str) => {
  return cyrillicToTranslit().transform(str.toLowerCase(), '_');
};

export const transformArrToObj = (arr) => {
  if (!arr) return {};
  return arr.reduce((a, c) => {
    a[c.code] = { stringValue: c.stringValue, decimalValue: c.decimalValue };
    return a;
  }, {});
};

export const checkCollectionsDiff = (a, b) => {
  return !Object.keys(diff(transformArrToObj(a), transformArrToObj(b))).length;
};

export const formattingVariantProp = (type, value) => {
  switch (type) {
    case 'price':
    case 'oldPrice':
      return Number(value);
    default:
      return value;
  }
};

export const checkIfProductHasVariants = (product) => {
  return !!(product.variants && product.variants.length && product.variants[0].optionsUsed);
};

export const checkIfProductHaveMonoboxes = (product) => {
  return product.variants?.find((m) => m.parentPackageId);
};

export const findAllVariants = (variants) => variants.filter((v) => !v.parentPackageId);

export const findAllMonoboxes = (variants, currentVariantId) => {
  return variants.filter((v) => v.parentPackageId === currentVariantId);
};

export const getEshopType = (type) => {
  if (type === 'BERU') {
    return 'Яндекс.Маркет';
  }
  if (type === 'GOODS') {
    return 'Сбер Мега Маркет';
  }
  return type;
};

export const checkIfProductVariative = (product) => {
  if (product.type !== 'BUNDLE') return false;

  const requiredItems = product.variants?.[0].items?.find((i) => i.optional);

  return product.type === 'BUNDLE' && product.variants?.[0].items?.length && requiredItems;
};

export const getCurrentFeature = (options, i, features) => {
  if (options) {
    return !options[i].isNewFeature ? features.find((f) => f.code === options[i].code) : options[i];
  }
};

export const getVariantTitle = (item, features) => {
  if (item && item.optionsUsed) {
    const colorAndSizeData = item.optionsUsed.filter(
      (item) => item.code === 'size' || item.code === 'color',
    );

    let variantTitle = colorAndSizeData
      .sort((a, b) => ('' + a.code).localeCompare(b.code))
      .map((o, i) => {
        const currentFeature = getCurrentFeature(item.optionsUsed, i, features);
        if (currentFeature) {
          if (currentFeature.type === 'string') {
            return o.stringValue;
          }
          if (currentFeature.type === 'decimal') {
            return o.decimalValue;
          }
        }
        return false;
      })
      .join(' / ');

    const otherFeatures = item.optionsUsed.filter(
      (item) => item.code !== 'size' && item.code !== 'color',
    );

    if (otherFeatures.length > 0) {
      const otherTitles = otherFeatures
        .sort((a, b) => ('' + a.code).localeCompare(b.code))
        .map((o, i) => {
          const currentFeature = getCurrentFeature(item.optionsUsed, i, features);
          if (currentFeature) {
            if (currentFeature.type === 'string') {
              return o.stringValue;
            }
            if (currentFeature.type === 'decimal') {
              return o.decimalValue;
            }
          }
          return false;
        })
        .join(' / ');

      if (variantTitle.length > 0) {
        variantTitle += ` / ${otherTitles}`;
      } else {
        variantTitle += `${otherTitles}`;
      }
    }

    return variantTitle;
  }

  return '';
};

export const parseError = (err) => {
  if (err && err.data) {
    if (err.data.errors) {
      if (err.data.errors.length && err.data.errors[0].message) {
        return err.data.errors[0].message;
      }
    }
    if (err.data.message) {
      return err.data.message;
    }
  }

  return 'Неизвестная ошибка';
};

export const parseErrorArr = (err) => {
  if (err && err.data) {
    if (err.data.errors) {
      if (err.data.errors.length) {
        return err.data.errors.map((e) => e.message);
      }
    }
    if (err.data.message) {
      return [err.data.message];
    }
  }

  return ['Неизвестная ошибка'];
};

export const getYandexStoreImageMin = (value, size = 100) => {
  if (value && value.indexOf('https://storage.yandexcloud.net/') === 0) {
    const splitted = value.split('.');
    const extension = splitted.pop();
    value = splitted.join('.') + '-' + size + '.' + extension;
  }
  return value || mockImg;
};

export const getProductImageUrl = (item, size) => {
  let result = mockImg;
  let value = null;
  if (item.defaultImage) {
    value = item.defaultImage;
  }
  if (item.pictureUrl) {
    value = item.pictureUrl;
  }
  if (item.images && item.images.length) {
    const sortedFirst = item.images.sort((a, b) => Number(a.pos) - Number(b.pos))[0];
    value = sortedFirst.crop ? sortedFirst.crop : sortedFirst.url;
  }
  if (value) {
    result = getYandexStoreImageMin(value, size);
  }
  return result;
};

export const getVariantImageUrl = (variant, size) => {
  let result = mockImg;
  let value = null;
  if (variant.defaultImage) {
    value = variant.defaultImage;
  }
  if (value) {
    result = getYandexStoreImageMin(value, size);
  }
  return result;
};

export const getCollectionImageUrl = (variant, size) => {
  let result = mockImg;
  let value = null;
  if (variant.defaultImage) {
    value = variant.defaultImage;
  }
  if (value) {
    result = getYandexStoreImageMin(value, size);
  }
  return result;
};

export const getItemStocks = (product, variant) => {
  if (!variant) {
    if (product.variants && product.variants.length) {
      return product.variants[0].stockAvailable;
    }
  } else {
    return variant.stockAvailable;
  }
  return null;
};

export const getItemDefaultBarcode = (variant) => {
  let barcode = null;
  if (variant && variant.barcodes && variant.barcodes.length) {
    const findDefault = variant.barcodes.find((b) => b.isDefault && b.value);
    if (findDefault) {
      barcode = findDefault;
    } else {
      const findWithValue = variant.barcodes.find((b) => b.value);
      if (findWithValue) {
        barcode = findWithValue;
      }
    }
  }
  return barcode;
};

export const getInitialStock = (warehouses, existData) => {
  if (existData) {
    const result = existData.slice();
    warehouses.forEach((w) => {
      if (!result.find((r) => r.warehouseCode === w.code)) {
        result.push({
          warehouseCode: w.code,
          stockAvailable: 0,
          stockReserved: 0,
          stockTotal: 0,
          stockDefective: 0,
        });
      }
    });
    return result;
  }

  return warehouses.map((w) => ({
    warehouseCode: w.code,
    stockAvailable: 0,
    stockReserved: 0,
    stockTotal: 0,
    stockDefective: 0,
  }));
};

export const getAdvancingBagdeStyle = (item) => {
  const { status } = item;

  if (status === 'PAID') {
    return {
      title: 'Оплачен',
      style: {
        color: '#fff',
        background: '#1ABC9C',
        borderColor: '#1ABC9C',
      },
    };
  }

  if (status === 'AWAITING_PAYMENT') {
    return {
      title: 'Ожидает оплаты',
      style: {
        background: '#F7B84B',
        borderColor: '#F7B84B',
        color: '#fff',
      },
    };
  }

  if (status === 'PARTIALLY_PAID') {
    return {
      title: 'Оплачен частично',
      style: {
        background: '#4FC6E1',
        borderColor: '#4FC6E1',
        color: '#fff',
      },
    };
  }

  if (status === 'EXPIRED') {
    return {
      title: 'просрочен',
      style: {
        background: '#F1556C',
        borderColor: '#F1556C',
        color: '#fff',
      },
    };
  }

  if (status === 'NEW') {
    return {
      title: 'Новый',
      style: {
        color: '#fff',
        background: 'rgb(143 107 208)',
        borderColor: 'rgb(143 107 208)',
      },
    };
  }

  return { title: '', style: {} };
};

export const getPaymentBagdeStyle = (currentProduct, currencySymbol) => {
  const { status, paymentMethodType, paymentStatus, codPayments } = currentProduct;

  if (
    paymentStatus === 'PAID' &&
    (paymentMethodType === 'ONLINE' ||
      paymentMethodType === 'NO_COD' ||
      paymentMethodType === 'NO_COD_NO_CONTROL')
  ) {
    return {
      title: 'Оплачен',
      style: {
        color: '#5e827a',
        background: 'linear-gradient(90deg, rgba(216,244,238,1) 0%, rgba(168,241,225,1) 100%)',
        borderColor: '#b7e2d9',
      },
    };
  }

  if (
    paymentStatus === 'NOT_PAID' &&
    (paymentMethodType === 'ONLINE' || paymentMethodType === 'NO_COD')
  ) {
    return {
      title: 'Ожидание оплаты',
      style: {
        background: 'linear-gradient(90deg, rgba(255,247,230,1) 0%, rgba(255,236,201,1) 100%)',
        borderColor: '#fdebcd',
        color: '#806027',
      },
    };
  }

  if (paymentStatus === 'NOT_PAID' && paymentMethodType === 'NO_COD_NO_CONTROL') {
    return {
      title: 'Без контроля оплаты',
      style: {
        background: 'linear-gradient(90deg, rgba(236,236,236,1) 0%, rgba(227,227,229,1) 100%)',
        borderColor: '#d8d8da',
        color: '#3b3c40',
      },
    };
  }

  if (paymentMethodType === 'COD_CARD' || paymentMethodType === 'COD_CASH') {
    if (codPayments) {
      return {
        title: 'Оплата при доставке | Оплачен',
        subtitle: `ФАКТИЧЕСКИЙ НП: ${codPayments?.[0]?.sum ?? 0} ${currencySymbol ?? '₽'}`,
        style: {
          background: 'linear-gradient(90deg, rgba(216,244,238,1) 0%, rgba(168,241,225,1) 100%)',
          borderColor: '#b7e2d9',
          color: '#5e827a',
        },
        icon: 'fe-check-circle',
      };
    }

    const statuses = Object.keys(INFO_STATUS_BAR_TRANSLATE);
    const orderInfoCourierIndex = statuses.findIndex((key) => key === 'ORDER_INFO_COURIER');
    const showClockLabel =
      orderInfoCourierIndex !== -1 &&
      statuses.findIndex((key) => key === status) >= orderInfoCourierIndex;
    if (showClockLabel) {
      return {
        title: 'Оплата при доставке',
        style: {
          background: 'linear-gradient(90deg, rgba(220,244,249,1) 0%, rgba(194,237,246,1) 100%)',
          borderColor: '#c1ecf4',
          color: '#296775',
        },
        icon: 'fe-clock',
      };
    }

    return {
      title: 'Оплата при доставке',
      style: {
        background: 'linear-gradient(90deg, rgba(220,244,249,1) 0%, rgba(194,237,246,1) 100%)',
        borderColor: '#c1ecf4',
        color: '#296775',
      },
    };
  }

  return { title: '', style: {} };
};

export const saveBase64AsPdf = (data) => {
  const reportBlob = dataURItoBlob('data:application/octet-stream;base64,' + data.content);
  saveAs(reportBlob, data.fileName);

  function dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    var blob = new Blob([ab], { type: mimeString });
    return blob;
  }
};

export const downloadFileViaDirectLink = (url, fileName) => {
  const link = document.createElement('a');
  link.style = 'display: none';
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // On Edge, revokeObjectURL should be called only after
  // a.click() has completed, atleast on EdgeHTML 15.15048
  setTimeout(function () {
    window.URL.revokeObjectURL(url);
  }, 1000);
};

export const saveOctetStreamAsFile = (data) => {
  const blob = new Blob([data.content], { type: 'application/octet-stream' });
  const url = window.URL.createObjectURL(blob);
  const fileName = data.fileName;

  downloadFileViaDirectLink(url, fileName);
};

/**
 * Формирует строку для get-запроса типа ?a=aaa&b=bbb&c=ccc
 *
 * @param params - объект параметров. Ключи - парамерты, значения соответстсвенно их значения. Если парамер пустой - возвращает пустую строку. Параметры для пустых полей объекта не добавляет.
 * @returns {string}
 */
export const makeGetString = (params) => {
  if (!params) {
    return '';
  }
  let str = '';
  for (let key in params) {
    if (params.hasOwnProperty(key) && params[key]) {
      str += (str ? '&' : '?') + key + '=' + params[key];
    }
  }
  return str;
};

export const previewEmailTemplate = (template, header, footer, data = {}) => {
  const itemImgUrl =
    'data:image/png;base64,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';
  let preview = template
    //Заголовок и подвал подставляем до других замен, поэтому замены сработают и в них тоже
    .replace('{liteHeader}', header)
    .replace('{liteFooter}', footer)

    .replace('{orderNum}', '1001')
    .replace('{shopName}', data.shopName) //$('#settings-shopname').val()
    .replace('{deliveryAddress}', 'г Москва, проезд Нижнелихоборский 3-й, д 5 стр 4, кв 3')
    .replace('{orderLink}', data.orderLink)
    .replace('${item.num}', '1')
    .replace('${item.imgUrl}', itemImgUrl)
    .replace('${item.name}', 'Lavazza Intenso')
    .replace('${item.quantity}', '2')
    .replace('${item.priceWithVat}', '300')
    .replace('${item.totalWithVat}', '600')
    .replace('{totalSumWithVAT} ', '600')
    //Убираем директивы шаблонизатора, например <#list items as item>. Важно, т.к. иначе парсинг вылетит по ошибке
    .replace(/<\/?#.*?>/giu, '');

  return preview;
};

export const b64DecodeUnicode = (str) => {
  return decodeURIComponent(
    Array.prototype.map
      .call(atob(str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );
};

export const b64EncodeUnicode = (str) => {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16));
    }),
  );
};

export const scrollToBlock = (blockId) => {
  const $block = document.getElementById(blockId);
  $block.scrollIntoView({ block: 'start', behavior: 'smooth' });
};

export const statusOptions = Object.keys(INFO_STATUS_BAR_TRANSLATE)
  .filter((key) => key !== 'ORDER_INFO_DONE')
  .map((key) => ({ value: key, label: INFO_STATUS_BAR_TRANSLATE[key] }));

export const suppliesStatusOptions = Object.keys(SUPPLY_STATUS_TRANSLATE).map((key) => ({
  value: key,
  label: SUPPLY_STATUS_TRANSLATE[key],
}));

export const typeOfSelectionByDateOptions = Object.keys(SELECTION_BY_DATE_TRANSLATE).map((key) => ({
  value: key,
  label: SELECTION_BY_DATE_TRANSLATE[key],
}));

export const getStateForButtonFilter = (filter) => {
  switch (filter) {
    case 'unpackingFilter':
      return 'ORDER_INFO_READY_TO_PACK';
    case 'controlPackingFilter':
      return 'ORDER_INFO_IN_PACKING';
    default:
      return '';
  }
};

export const getNdsValue = (name) => {
  switch (name) {
    case 'NO_VAT':
      return null;
    case 'VAT_0':
      return 0;
    case 'VAT_5':
      return 5;
    case 'VAT_7':
      return 7;
    case 'VAT_10':
      return 10;
    case 'VAT_18':
      return 18;
    case 'VAT_20':
      return 20;
    default:
      return null;
  }
};

export const getCurrencySymbol = (currency) => {
  if (!currency) return '₽';

  switch (currency) {
    case 'RUB':
      return '₽';
    case 'USD':
      return '$';
    case 'EUR':
      return '€';
    case 'KZT':
      return '₸';
    case 'UAH':
      return '₴';
    default:
      return currency;
  }
};

export const getCurrencyName = (currency) => {
  if (!currency) return 'Рубли';

  switch (currency) {
    case 'RUB':
      return 'Рубли';
    case 'USD':
      return 'Доллары США';
    case 'EUR':
      return 'Евро';
    case 'KZT':
      return 'Тенге';
    case 'UAH':
      return 'Гривны';
    default:
      return currency;
  }
};

export const formatBytes = (a, b = 2) => {
  if (0 === a) return '0 Bytes';
  const c = 0 > b ? 0 : b,
    d = Math.floor(Math.log(a) / Math.log(1024));
  return parseFloat((a / Math.pow(1024, d)).toFixed(c)) + ' ' + ['Байт', 'Кб', 'Мб', 'Гб', 'Тб'][d];
};

export const getFullAddress = ({
  zip,
  region,
  area,
  city,
  settlement,
  street,
  house,
  block,
  building,
  flat,
  floor,
  fullAddress,
  rawData,
}) => {
  let result = '';
  if (zip) result += `${zip}, `;
  if (region) result += `${region}, `;
  if (area) result += `${area}, `;
  if (city) result += `${city}, `;
  if (settlement) result += `${settlement}, `;
  if (street) result += `${street}, `;
  if (house) result += `д.${house} `;
  if (block) result += `к.${block} `;
  if (building) result += `стр.${building} `;
  if (flat) result += `кв.${flat} `;
  if (floor) result += `эт.${floor} `;

  const isOnlyZipExist =
    zip &&
    !(
      region ||
      area ||
      city ||
      settlement ||
      street ||
      house ||
      block ||
      building ||
      flat ||
      floor
    );

  if (isOnlyZipExist && rawData) {
    result = `${zip}, ${rawData}`;
  }

  return result ? result : fullAddress || '';
};

export const getDeliveryItem = (code, deliveryInfo) => {
  return (deliveryInfo && deliveryInfo.find((d) => d.code === code)) || {};
};

export const encodeHashSymbol = (str) => str.replace(/#/g, '%23');

export const getPositiveSum = (sum) => {
  return numeral(Math.abs(sum)).format('0,0.00');
};

export const getMoneyFormat = (price) => {
  return numeral(price).format('0,0.00');
};

export const getType = (item) => {
  if (item.type === 'BUNDLE') {
    if (item.variants[0].items && item.variants[0].items.length) {
      const newRequiredQuantity = item.variants[0].items.reduce((acc, item) => {
        return acc + +!item.optional;
      }, 0);
      if (item.variants[0].items.length !== newRequiredQuantity) {
        return 'VARIATIVE';
      } else {
        return item.type;
      }
    } else {
      return item.type;
    }
  } else {
    return item.type;
  }
};

export const isNegative = (num) => {
  if (num === '0.00') {
    return 'default';
  }

  if (num) {
    if (String(num).includes('-')) {
      return 'neg';
    } else {
      return 'pos';
    }
  }
};

export const checkOrderConfirmation = (currentOrder) => {
  return !(
    currentOrder.confirmStatus === 'NEED_CONFIRM' ||
    currentOrder.status === 'ORDER_INFO_CONFIRM_HOLD' ||
    (currentOrder.confirmStatus === 'HOLD' && currentOrder.status !== 'ORDER_INFO_CANCELED')
  );
};

export const checkDelivered = (status) => {
  return (
    status === 'ORDER_INFO_DELIVERED' ||
    status === 'ORDER_INFO_PARTIALLY_DELIVERED_NOT_RETURNED' ||
    status === 'ORDER_INFO_PARTIALLY_DELIVERED_RETURNED'
  );
};

export const encodeId = (id) => encodeURI(id).replaceAll('#', '%23');
export const decodeId = (id) => decodeURI(id).replaceAll('%23', '#');

export const getProductEncodedUrl = (productId, variantId, params = {}, isMonobox = false) => {
  let url = `/items/${productId}`;

  if (typeof variantId !== 'undefined') {
    url += `${isMonobox ? '/monoboxes/' : '/variants/'}` + variantId;
  }

  if (params) {
    let paramsStr = '?';
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        if (paramsStr !== '?') {
          paramsStr += '&';
        }
        paramsStr += value === true ? key : `${key}=${value}`;
      }
    });

    if (paramsStr !== '?') {
      url += paramsStr;
    }
  }

  return encodeURI(url).replaceAll('#', '%23');
};

export const checkIsFbm = (delivery, deliveryInfo) => {
  const deliveryCode = deliveryInfo?.find((info) => info.code === delivery?.code);
  return !!deliveryCode?.fbmType;
};

export const getFbmType = (delivery, deliveryInfo) => {
  const deliveryCode = deliveryInfo?.find((info) => info.code === delivery?.code);
  return deliveryCode?.fbmType;
};

export const getFBMDeliveryTitle = (delivery, deliveryInfo, t = null) => {
  const deliveryCode = deliveryInfo?.find((info) => info.code === delivery.code);
  const description = t ? t('поставка на маркетплейс') : 'поставка на маркетплейс';
  return deliveryCode?.fbmType ? (
    <span>
      FBM {deliveryCode.fbmType} - {description}
    </span>
  ) : null;
};

export const getDeliveryBlock = (deliveryCode, deliveryInfoList) => {
  const deliveryByCode = deliveryInfoList?.find((delivery) => delivery.code === deliveryCode);
  const types = {
    PVZ: 'ПВЗ',
    COURIER: 'Курьер',
  };
  const type = types[deliveryByCode?.type];

  if (!deliveryByCode) return null;

  if (deliveryByCode.fbmType === 'OZON') {
    return 'OZON FBO';
  }

  if (deliveryByCode.fbmType === 'WILDBERRIES') {
    return 'WILDBERRIES FBW';
  }

  return `${deliveryByCode?.courierTitle} ${type ? '- ' + type : ''}`;
};

export const checkIsInteger = (value) => {
  if (value === '0') {
    return false;
  }
  return /^[0-9]+$/.test(value) || value === '';
};

export const findUniqueObjects = (firstArray, secondArray) => {
  const secondIds = new Set(secondArray.map((obj) => obj.variantId));
  return firstArray.filter((obj) => !secondIds.has(obj.variantId) && obj.name !== 'Доставка');
};

export const sortRussianThenEnglishByKey = (items, key) => {
  if (!key) return items;

  const isRussian = (text) => /[а-яё]/i.test(text);

  const russianItems = items
    .filter((item) => isRussian(item[key]))
    .sort((a, b) => a[key].localeCompare(b[key], 'ru'));

  const englishItems = items
    .filter((item) => !isRussian(item[key]))
    .sort((a, b) => a[key].localeCompare(b[key], 'en'));

  return [...russianItems, ...englishItems];
};

export const MARKETPLACE_ADDITIONAL_PROPERTIES = {
  warehouseIds: 'ID склада',
  autoTariffication: 'Автоматическая тарификация доставки',
  autoConfirmOrders: 'Автоматически подтверждать заказы',
  enableCleanAddress: 'Включить платную проверку адресов через DaData',
  excludeFromAwaitingReturnReport: 'Исключить из отчета по возвратам',
  skipNotFoundSku: 'Пропускать заказы, если номенклатура не найдена',
  searchForNearestPvz: 'Поиск ПВЗ',
};

export const POSSIBLE_MASKS = [
  { value: 'honest_sign', label: 'Честный знак' },
  { value: 'length_check', label: 'Проверка по длине' },
  { value: 'regular_expression', label: 'Регулярное выражение' },
];
